<template>
	<div class="wrap" :style="{backgroundImage: 'url(' + backImg[active] + ')', backgroundAttachment: 'fixed', backgroundSize:'100% 100%', backgroundRepeat: 'no-repeat', backgroundPosition: 'center 0'}">
		<div class="pc" v-if="type">
			<div class="menu-wrap">
				<div class="logo">
					<img src="../assets/images/logo2.png">
				</div>
				<div class="menu" :class="active == y?'active':''" v-for="(x,y) in menu" :key="x.path" @click="handlePage(x.path,y)">
					<div class="menu-text">{{x.name}}</div>
				</div>
			</div>
			<div class="content" ref="content">
				<div class="con-box">
					<div class="phone-wrap">合作热线：400-970-0125</div>
					<router-view></router-view>
				</div>
				<div class="foot-wrap">
					费而隐 feieryin.com 费而隐科技有限公司&nbsp;&nbsp;电话：400-970-0125<br>
					&nbsp;&nbsp;陇ICP备19003235号-11
				</div>
			</div>
		</div>
		<div class="touch" v-if="!type">
			<div class="p20">
				<div class="overflow">
					<div class="fixed-left lt">
						<img src="../assets/images/white_logo.png">
					</div>
					<div class="fixed-right rt">
						合作热线：400-970-0125
					</div>
				</div>
				<div class="overflow m20">
					<div class="menu" :class="active == y?'active':''" v-for="(x,y) in menu" :key="x.path" @click="handlePage(x.path,y)">
						<div class="menu-text">{{x.name}}</div>
					</div>
				</div>
				<router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	// import 
	export default{
		data(){
			return {
				menu:[
					{name:'首页',path:'/'},
					{name:'定制研发',path:'/devlop'},
					{name:'关于我们',path:'/about'},
					{name:'招贤纳士',path:'/invite'}
				],
				backImg:[
					require('../assets/images/shouye_bg.jpg'),require('../assets/images/dingzhi_bg.jpg'),require('../assets/images/about_bg.jpg'),require('../assets/images/zhaoxian_bg.jpg')
				],
				active:0,
				timer:null,
				type: ''
			}
		},
		created(){
			let href = location.href.split('#')[1];
			this.$router.options.routes.forEach((item,i)=>{
				if(item.path == href){
					this.active = i;
				}
			})
			this.type = this.IsPC()
		},
		mounted(){
			
		},
		methods:{
			IsPC() {
			    var userAgentInfo = navigator.userAgent;
			    var Agents = ["Android", "iPhone",
			                "SymbianOS", "Windows Phone",
			                "iPad", "iPod"];
			    var flag = true;
			    for (var v = 0; v < Agents.length; v++) {
			        if (userAgentInfo.indexOf(Agents[v]) > 0) {
			            flag = false;
			            break;
			        }
			    }
			    return flag;
			},
			handlePage(x,y){
				if (this.type) {
					if (document.documentElement.scrollTop > 0) {
						document.documentElement.scrollTop = 0
					} else if (document.body.scrollTop > 0) {
						document.body.scrollTop = 0
					}
					this.$refs.content.scrollTop = 0;
				}
				this.active = y;
				this.$router.push(x)
			},
		}
	}
	
</script>

<style>
	.pc .tit-text {
		font-size: 40px;
	}
	.touch .tit-text {
		font-size: 0.4rem;
	}
	.touch .dev-mid-p {
		font-size: 0.32rem;
		margin-bottom: 0.7rem;
	}
	.touch .head {
		height: 6rem;
	}
	.touch .head .head-con {
		height: 100%;
		width: 100%;
		background-size: 100%;
		background-position: center 0;
		background-repeat: no-repeat;
	}
	.dev-mid-p {
		color: #fff;
	}
	.tit-text{
		text-align: center;
		letter-spacing: 4px;
		font-weight: bold;
	}
	.touch {
		font-size: 0.48rem;
		margin: auto;
	}
	.touch .p20 {
		padding: 0.5rem;
	}
	.touch .overflow {
		overflow: hidden;
	}
	.touch .fixed-left {
		width: 3rem;
	}
	.touch .fixed-left img {
		max-width: 100%;
	}
	.touch .fixed-right {
		color: #fff;
		text-align: right;
		line-height: 1.05rem;
	}
	.touch .m20 {
		margin: 0.5rem 0;
	}
	.touch .menu {
		float: left;
		width: 25%;
		text-align: center;
		background-color: rgba(255,255,255,.28);
	}
	.touch .menu.active{
		background-color: rgba(255,255,255,.7);
	}
	.pc .wrap{
		width: 100%;
		height:100%;
		background-color: #699dde;
	}
	.pc .wrap>img{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	.pc .content{
		width: 100%;
		height: 100%;
	}
	.pc .con-box {
		width: 1212px;
		min-height: 765px;
		margin: auto;
		position: relative;
	}
	.pc .logo{
		width: 80%;
		margin: 10px auto;
	}
	.pc .mask{
		width: 100%;
		height: 100%;
		background: rgba(68,138,202,.3);
		position: absolute;
		z-index: 1;
	}
	.pc .logo>img{
		max-width:100%;
		display: block;
	}
	.pc .menu-wrap{
		width: 160px;
		position: fixed;
		left: 160px;
		background: rgba(255,255,255,.28);
		user-select: none;
		z-index: 99;
	}
	.pc .phone-wrap {
		width: 262px;
		font-size: 22px;
		position: absolute;
		right: 0;
		top: 15px;
		user-select: none;
		z-index: 99;
		color: #fff;
	}
	.pc .menu{
		width:100%;
		text-align:center;
		font-size: 18px;
		padding: 8px 0;
		cursor:pointer;
		user-select: none;
		font-weight: bold;
	}
	.pc .menu-text{
		width:50%;
		text-align: left;
		margin: 0 auto;
	}
	.pc .menu-wrap .active{
		background:rgba(255,255,255,.5);
	}
	.pc .foot-wrap {
		width: 100%;
		background: rgba(0,0,0,.5);
		padding: 30px 0;
		margin-top: 90px;
		color: #fff;
		font-size: 16px;
		text-align: center;
		line-height: 32px;
	}
	.touch .dev-mid-tit{
		padding: 0.2rem 0;
		width: 5.8rem;
		margin: 0.3rem auto;
		font-size: 0.12rem;
	}
	.pc .dev-mid-tit{
		padding: 20px 0;
		font-size: 18px;
		width: 580px;
		margin: 30px auto;
	}
	.dev-mid-tit{
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		
	}
</style>
